/**
 * Russian locale catalogs for the host app layer.
 *
 * Mirrors the English shape in `./en.ts` (`typeof appHostEn`). Product
 * names and the `user_id` / `discord_id` keys are not translated; route
 * names remain English so Vue Router resolves them unchanged.
 */
import type { LocaleCatalogShape } from '@/shared/i18n'
import type { appHostEn } from './en.ts'

export const appHostRu: LocaleCatalogShape<typeof appHostEn> = {
  nav: {
    calendar: 'Календарь',
    raidPlan: 'План рейда',
    officers: 'Настройки гильдии',
    auditLog: 'Журнал действий',
    onboarding: 'Подключение',
    myBuilds: 'Мои билды',
  },
  profilePopover: {
    myBuilds: 'Мои билды',
  },
  routeTitle: {
    calendar: 'Календарь',
    'gvg-planner': 'GvG-планировщик',
    officers: 'Настройки гильдии',
    'audit-log': 'Журнал действий',
    onboarding: 'Подключение',
    'my-builds': 'Мои билды',
    'not-found': 'Не найдено',
  },
} as const
